
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'ArrowUp'
})
export default class ArrowUp extends Vue {}
